
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Badge from 'vux/src/components/badge/index.vue'

import config from '@/config/index'
import { getaddlog } from '@/api/hgfw'
import { myDeal } from '@/api/youzheng.js'
export default {
name: 'workIndex',
data () {
return {
selected: parseInt(this.$route.params.selected),
accounttype: this.$store.state.user.personObj.accounttype,
isqyb: this.$store.state.user.personObj.isqyb,
mydeal: 0,
myquestion: 0
}
},
components: {
Tabbar,
TabbarItem,
Badge
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
$route () {
this.selected = parseInt(this.$route.params.selected)
}
},
methods: {
getmydeal () {
myDeal({
accountid: this.accountid,
idtype: 2,
userid: this.userid
}).then(res => {
this.mydeal = res.obj.mydeal
this.myquestion = res.obj.myquestion
})
},

getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120116
}).then(res => {
})
},
goshenbao () {
this.$router.push({ name: 'myMailWorkdeclare', params: { selected: 0 } })
},
gozixun () {
this.$router.push({ name: 'myMailWorkZixun', params: { selected: 1 } })
},
godaiban () {
if (this.isqyb === 1) {
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 0 } })
} else {
this.$router.push({ name: 'myMailWorkQyDaiban', params: { selected: 2, tabIndex: 0 } })
}
}
},
activated () { },
created () {
this.getmydeal()
this.getAdd()
}
}
